/**
 * Something the user just did that Abekus AI's orb speaks up about right
 * after (GET /assistant/nudge): most applicants visit once, so the orb follows
 * what they do rather than a clock. Fired from wherever the thing happens --
 * a thunk, a click handler -- and picked up by the orb (useOrbPrompt), which
 * waits for a calm moment to say it.
 */
export type AssistantMomentKind =
  | 'job_applied'
  | 'external_apply'
  | 'resume_done'
  | 'lesson_done';

export interface AssistantMoment {
  kind: AssistantMomentKind;
  /** The job's or course's id, when the moment is about one. */
  subject?: string | null;
}

export const ASSISTANT_MOMENT_EVENT = 'abekus-assistant-moment';

export const announceAssistantMoment = (
  kind: AssistantMomentKind,
  subject?: string | null,
) =>
  window.dispatchEvent(
    new CustomEvent<AssistantMoment>(ASSISTANT_MOMENT_EVENT, {
      detail: { kind, subject: subject ?? null },
    }),
  );
